<script>
export default {
  methods: {
    brancheIcon (id) {
      let category
      switch (id) {
        case 6:
          category = 'auto-fiets'
          break
        case 7:
        case 9:
        case 16:
        case 18:
        case 19:
        case 20:
        case 22:
        case 23:
          category = 'winkeliers'
          break
        case 8:
          category = 'horeca'
          break
        case 10:
        case 27:
          category = 'gemeente'
          break
        case 11:
        case 25:
          category = 'star'
          break
        case 12:
          category = 'inwoners'
          break
        case 13:
        case 29:
          category = 'sport'
          break
        case 14:
          category = 'beauty'
          break
        case 15:
          category = 'zorg'
          break
        case 17:
          category = 'shopping-cart'
          break
        case 21:
          category = 'wonen'
          break
        case 24:
          category = 'dierentuin'
          break
        case 26:
          category = 'admin-2'
          break
        default:
          category = 'star'
      }
      return 'enjoj-' + category
    }
  }
}
</script>
